import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-pratiche-detail',
	templateUrl: './pratiche-detail.component.html',
	styleUrls: ['./pratiche-detail.component.css']
})
export class PraticheDetailComponent implements OnInit {
	@Input() public uid: any = 0;
	dettagliPratica: any[] = [];
	dettagliPraticheSync: Subscription;

	infoPratica: any = null;
	viewDetail: any = {};
	viewedDetail: string = '';

	num_dettagli: number = 0;
	spese_notifica_agg: number = 0;
	oneri_risc: number = 0;
	spese_esecutive: number = 0;

	public formatter : any;

	constructor(private dataService: DataService) {
		this.formatter = this.dataService.getCommon().getLocale();
	}

	ngOnInit() {
		this.dettagliPraticheSync = this.dataService.praticheDettagli$.subscribe(
			(praticheDettagli) => {
				this.getDetails();
			});
	}

	getDetails() {
		console.log("PRATICHE | details inizio", this.uid);
		//	getPraticaDettagli
		this.dataService.getDettagliByUid(this.uid, (localDettagli) => {
			this.dettagliPratica = localDettagli;
			console.log("PRATICHE | details dettagliPratica", this.dettagliPratica);
			this.setViewDetail();
			this.fillSummedAttributePraticaDettagli();
		});

		//	getPratica
		this.dataService.getPraticaById(this.uid, (localPratica) => {
			this.infoPratica = localPratica;
			console.log("PRATICHE | get infoPratica", this.infoPratica);
			this.fillSummedAttributePratica();
		});
		console.log("PRATICHE | details", this.infoPratica, this.dettagliPratica);
	}

	setViewDetail() {
		for (let row of this.dettagliPratica) {
			this.viewDetail[row.uid] = false;
		}
	}

	switchDetail(uid: any) {
		if (this.viewedDetail != '') {
			this.viewDetail[this.viewedDetail] = false;
		}
		if (uid != this.viewedDetail) {
			this.viewDetail[uid] = true;
			this.viewedDetail = uid;
		}else {
			this.viewedDetail = '';
		}
	}

	fillSummedAttributePraticaDettagli(){
		for(let row of this.dettagliPratica){
			this.oneri_risc += Number(row.oneri_risc_attuali);
			this.num_dettagli++;
		}
	}

	fillSummedAttributePratica(){
		this.spese_esecutive = 0.00;
		this.spese_notifica_agg = 0.00;
		if(this.infoPratica){
			this.spese_esecutive = Number(this.infoPratica.diritti_pf_agg) + Number(this.infoPratica.diritti_pf_agg_prec);
			this.spese_notifica_agg += Number(this.infoPratica.notifica_spese_agg) + Number(this.infoPratica.notifica_spese_agg_prec);
		}
	}

	exportData() {
		console.log('export data');
		let filename = 'Dettagli Pratica';
		let data = [];
		for (let dettaglio of this.dettagliPratica) {
			let item = {};
			item['Tributo'] = dettaglio.tributo;
			item['Fase'] = dettaglio.fase;
			item['Anno'] = dettaglio.anno;
			item['+'] = "";
			if(dettaglio.anno_suppl){
				item['+'] = dettaglio.anno_suppl;
			}
			item['Dovuto'] = this.formatter.toCurrency(dettaglio.dovuto);
			item['Arrotondamento'] = this.formatter.toCurrency(dettaglio.arrotondamento);
			item['Versato'] = this.formatter.toCurrency(dettaglio.versato);
			item['Sanzioni'] = this.formatter.toCurrency(dettaglio.sanzioni);
			item['Interessi'] = this.formatter.toCurrency(dettaglio.interessi);
			item['Spese notifica'] = this.formatter.toCurrency(dettaglio.notifica_spese);
			item['Oneri riscossione'] = this.formatter.toCurrency(dettaglio.oneri_risc_attuali);
			item['Interessi aggiuntivi'] = this.formatter.toCurrency(dettaglio.interessi_agg);
			item['Note'] = "";
			if(dettaglio.anno_suppl){
				item['Note'] = dettaglio.note;
			}
			data.push(item);
		}
		this.dataService.exportCsv(filename,data);
	}

	ngOnDestroy() {
		this.dettagliPraticheSync.unsubscribe();
	}
}
